<template>
  <v-layout row justify-center>
    <v-dialog v-model="visibility" persistent max-width="290">
      <v-card>
        <v-layout column pa-4>

          <MutableButton
            :actionColor="'cyan'"
            :confirmColor="'green'"
            @confirm="$emit('confirmAbsent')"
            v-if="visibility && !isAlreadyAbsent"
            data-test="button-confirm">
              <template slot="confirmText">
                Confirmar
              </template>
              Ausente
          </MutableButton>

          <MutableButton
            :actionColor="'cyan'"
            :confirmColor="'green'"
            @confirm="$emit('confirmPresent')"
            v-else-if="visibility && isAlreadyAbsent"
            data-test="button-confirm">
              <template slot="confirmText">
                Confirmar
              </template>
              Presente
          </MutableButton>

          <v-btn block color="red" class="white--text" @click="$emit('cancel')">Cancelar</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import MutableButton from '@/components/MutableButton'

export default {
  name: 'absentStudent',

  data: () => ({
    confirmText: 'Confirmar',
    timeout: 5000
  }),

  props: {
    visibility: {
      type: Boolean,
      default: true
    },
    isAlreadyAbsent: {
      type: Boolean,
      required: true
    }
  },

  components: {
    MutableButton
  }
}
</script>
